import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {Video} from "../home/home-youtube/video.model";
import {CommonHttpService, optimistic} from "./common-http.service";
import {AuthHttpService} from "./auth-http.service";

@Injectable({
  providedIn: 'root'
})
export class ChannelApiService {

  constructor(
    private http: CommonHttpService,
    private authHttp: AuthHttpService
  ) { }

  getAll(): Observable<Array<Video>> {
    return this.http.get<Array<Video>>("/videos").pipe(optimistic);
  }

  save(video: Video) {
    return this.authHttp.post<void>("/videos", video);
  }

  update(video: Video) {
    return this.authHttp.put<void>("/videos/" + video.id, video);
  }

  delete(video: Video) {
    return this.authHttp.delete<void>("/videos/" + video.id);
  }

}
